












import { Component, Vue } from 'vue-property-decorator'
import { Alert } from '@finx/web-repository/src/types/Alert'

@Component

export default class ViewAlerta extends Vue {
  alert: Alert = {
    show: false,
    buttons: [],
    icon: '',
    iconColor: '',
    subtitle: '',
    title: '',
  }

  alertaType: String = ''

  data() {
    return {
      alertaType: this.$route.params.alertaType,
    }
  }

  mounted() {
    this.setAlert(this.alertaType)
  }

  setAlert(alert) {
    if (alert === 'atualizacao-encontrada') {
      this.alert = {
        show: true,
        buttons: [
          {
            text: 'Atualizar',
            action: '/update',
            color: 'primary',
            flat: false,
          },
        ],
        icon: 'refresh',
        iconColor: 'success',
        subtitle: 'Atualize o aplicativo clicando no botão abaixo',
        title: 'Atualização disponível',
      }
    }
  }
}
